// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"81f8588c","455":"9001931a","977":"a16da0a1"}[chunkId] + ".chunk.js";
};